import React, { useState } from 'react';
import { C, FONT_BODY, BG, CARD_STYLE } from '../theme';

// ─── Illustrazioni SVG brandkit ───────────────────────────────────────────────
// Sfondo bianco, pattern geometrici minimal, accent color per categoria

function IllustrationProgressione({ color }) {
  return (
    <svg width="100%" viewBox="0 0 360 180" fill="none" style={{ display: 'block' }}>
      <rect width="360" height="180" fill="#fff"/>
      {/* Grid lines */}
      {[40, 80, 120, 160].map(y => (
        <line key={y} x1="40" y1={y} x2="320" y2={y} stroke="rgba(0,0,0,0.04)" strokeWidth="1"/>
      ))}
      {[80, 160, 240].map(x => (
        <line key={x} x1={x} y1="20" x2={x} y2="160" stroke="rgba(0,0,0,0.04)" strokeWidth="1"/>
      ))}
      {/* Area fill */}
      <path d="M60,140 L100,110 L160,120 L220,80 L290,40 L290,160 L60,160Z" fill={color} fillOpacity="0.06"/>
      {/* Line */}
      <polyline points="60,140 100,110 160,120 220,80 290,40"
        stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      {/* Dots */}
      {[[60,140],[100,110],[160,120],[220,80]].map(([x,y],i) => (
        <circle key={i} cx={x} cy={y} r="4" fill="#fff" stroke={color} strokeWidth="2"/>
      ))}
      {/* End dot highlight */}
      <circle cx="290" cy="40" r="6" fill={color}/>
      <circle cx="290" cy="40" r="10" fill={color} fillOpacity="0.15"/>
      {/* Labels */}
      <text x="60" y="175" fontSize="10" fill="rgba(0,0,0,0.2)" fontFamily="system-ui" textAnchor="middle">Sett 1</text>
      <text x="160" y="175" fontSize="10" fill="rgba(0,0,0,0.2)" fontFamily="system-ui" textAnchor="middle">Sett 3</text>
      <text x="290" y="175" fontSize="10" fill="rgba(0,0,0,0.2)" fontFamily="system-ui" textAnchor="middle">Oggi</text>
    </svg>
  );
}

function IllustrationIntensita({ color }) {
  // Gauge centrato con cy=150 su viewBox 360x200 — ampio margine
  const cx = 180, cy = 155, r = 90;
  const toXY = (pct) => {
    const angle = Math.PI + pct * Math.PI; // 0=left, 1=right
    return [cx + r * Math.cos(angle), cy + r * Math.sin(angle)];
  };
  const [nx, ny] = toXY(0.75); // RPE 7.5/10 → 75%
  return (
    <svg width="100%" viewBox="0 0 360 200" fill="none" style={{ display: 'block' }}>
      <rect width="360" height="200" fill="#fff"/>
      {/* Track background */}
      <path d={`M${cx-r},${cy} A${r},${r} 0 0,1 ${cx+r},${cy}`}
        stroke="rgba(0,0,0,0.06)" strokeWidth="14" fill="none" strokeLinecap="round"/>
      {/* Track fill 0→75% */}
      {(() => {
        const [ex, ey] = toXY(0.75);
        return (
          <path d={`M${cx-r},${cy} A${r},${r} 0 0,1 ${ex},${ey}`}
            stroke={color} strokeWidth="14" fill="none" strokeLinecap="round" opacity="0.9"/>
        );
      })()}
      {/* Tacche */}
      {[0,1,2,3,4,5,6,7,8,9,10].map(i => {
        const [tx1, ty1] = [cx + (r-8)*Math.cos(Math.PI + (i/10)*Math.PI), cy + (r-8)*Math.sin(Math.PI + (i/10)*Math.PI)];
        const [tx2, ty2] = [cx + (r+8)*Math.cos(Math.PI + (i/10)*Math.PI), cy + (r+8)*Math.sin(Math.PI + (i/10)*Math.PI)];
        return <line key={i} x1={tx1} y1={ty1} x2={tx2} y2={ty2} stroke="rgba(0,0,0,0.08)" strokeWidth="1.5" strokeLinecap="round"/>;
      })}
      {/* Needle */}
      <line x1={cx} y1={cy} x2={nx} y2={ny} stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
      <circle cx={cx} cy={cy} r="7" fill={color}/>
      <circle cx={cx} cy={cy} r="4" fill="#fff"/>
      {/* Label */}
      <text x={cx} y={cy-22} fontSize="30" fontWeight="700" fill={color} fontFamily="system-ui" textAnchor="middle">7.5</text>
      <text x={cx} y={cy-6} fontSize="11" fill="rgba(0,0,0,0.28)" fontFamily="system-ui" textAnchor="middle">RPE</text>
      {/* Min/Max */}
      <text x={cx-r-4} y={cy+18} fontSize="10" fill="rgba(0,0,0,0.22)" fontFamily="system-ui" textAnchor="middle">1</text>
      <text x={cx+r+4} y={cy+18} fontSize="10" fill="rgba(0,0,0,0.22)" fontFamily="system-ui" textAnchor="middle">10</text>
    </svg>
  );
}

function IllustrationScore({ color }) {
  const bars = [
    { x:55,  h:44,  label:'Lun', opacity:0.28 },
    { x:110, h:64,  label:'Mar', opacity:0.42 },
    { x:165, h:36,  label:'Mer', opacity:0.28 },
    { x:220, h:88,  label:'Gio', opacity:0.65 },
    { x:275, h:74,  label:'Ven', opacity:1    },
  ];
  const baseline = 155;
  return (
    <svg width="100%" viewBox="0 0 360 180" fill="none" style={{ display: 'block' }}>
      <rect width="360" height="180" fill="#fff"/>
      {/* Grid lines */}
      {[60, 100, 140].map(y => (
        <line key={y} x1="30" y1={y} x2="330" y2={y} stroke="rgba(0,0,0,0.04)" strokeWidth="1"/>
      ))}
      {/* Bars */}
      {bars.map(b => (
        <g key={b.x}>
          <rect x={b.x-18} y={baseline-b.h} width="36" height={b.h} rx="7" fill={color} fillOpacity={b.opacity}/>
          <text x={b.x} y="170" fontSize="10" fill="rgba(0,0,0,0.22)" fontFamily="system-ui" textAnchor="middle">{b.label}</text>
        </g>
      ))}
      {/* Score badge */}
      <rect x="244" y="14" width="72" height="28" rx="9" fill={color} fillOpacity="0.1"/>
      <text x="280" y="32" fontSize="13" fontWeight="700" fill={color} fontFamily="system-ui" textAnchor="middle">82 pts</text>
    </svg>
  );
}

function IllustrationStallo({ color }) {
  return (
    <svg width="100%" viewBox="0 0 360 180" fill="none" style={{ display: 'block' }}>
      <rect width="360" height="180" fill="#fff"/>
      {/* Grid */}
      {[50,100,150].map(y => (
        <line key={y} x1="40" y1={y} x2="320" y2={y} stroke="rgba(0,0,0,0.04)" strokeWidth="1"/>
      ))}
      {/* Progressione iniziale */}
      <polyline points="50,150 90,120 130,95"
        stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      {/* Zona stallo evidenziata */}
      <rect x="130" y="70" width="120" height="60" rx="6" fill={color} fillOpacity="0.06"/>
      <line x1="130" y1="95" x2="250" y2="95" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeDasharray="6 4"/>
      {/* Punto stallo */}
      {[130,170,210,250].map((x,i) => (
        <circle key={i} cx={x} cy="95" r="4" fill="#fff" stroke={color} strokeWidth="2" fillOpacity={i===0||i===3?1:0.5}/>
      ))}
      {/* Label stallo */}
      <text x="190" y="82" fontSize="10" fontWeight="600" fill={color} fontFamily="system-ui" textAnchor="middle" opacity="0.7">3 sessioni piatte</text>
      {/* Freccia recovery */}
      <polyline points="250,95 290,60"
        stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.4"/>
      <circle cx="290" cy="60" r="4" fill={color} fillOpacity="0.4"/>
    </svg>
  );
}

function IllustrationDeload({ color }) {
  return (
    <svg width="100%" viewBox="0 0 360 180" fill="none" style={{ display: 'block' }}>
      <rect width="360" height="180" fill="#fff"/>
      {/* Onde — ciclo carico/deload */}
      {/* Blocco 1: accumulo */}
      <path d="M30,130 C50,120 70,80 90,75 C110,70 120,90 140,85 C150,82 160,72 180,70"
        stroke={color} strokeWidth="2.2" fill="none" strokeLinecap="round" opacity="0.85"/>
      {/* Zona deload evidenziata */}
      <rect x="180" y="50" width="60" height="100" rx="6" fill={color} fillOpacity="0.07"/>
      <text x="210" y="46" fontSize="10" fontWeight="600" fill={color} fontFamily="system-ui" textAnchor="middle">deload</text>
      {/* Deload dip */}
      <path d="M180,70 C195,100 205,110 240,108" stroke={color} strokeWidth="2.2" fill="none" strokeLinecap="round" opacity="0.5" strokeDasharray="5 3"/>
      {/* Blocco 2: supercompensazione */}
      <path d="M240,108 C260,105 275,75 295,55 C305,45 315,50 330,48"
        stroke={color} strokeWidth="2.2" fill="none" strokeLinecap="round" opacity="0.85"/>
      {/* Freccia su finale */}
      <line x1="310" y1="70" x2="310" y2="40" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
      <polyline points="305,46 310,40 315,46" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.5"/>
      {/* Etichette */}
      <text x="100" y="165" fontSize="10" fill="rgba(0,0,0,0.25)" fontFamily="system-ui" textAnchor="middle">Accumulo</text>
      <text x="285" y="165" fontSize="10" fill="rgba(0,0,0,0.25)" fontFamily="system-ui" textAnchor="middle">Rimbalzo</text>
    </svg>
  );
}

function IllustrationVolume({ color }) {
  const muscles = [
    { cx:72,  cy:90, r:48, label:'Petto',   sets:14, max:20 },
    { cx:180, cy:90, r:48, label:'Schiena', sets:18, max:20 },
    { cx:288, cy:90, r:48, label:'Gambe',   sets:8,  max:20 },
  ];
  return (
    <svg width="100%" viewBox="0 0 360 180" fill="none" style={{ display: 'block' }}>
      <rect width="360" height="180" fill="#fff"/>
      {muscles.map(m => {
        const pct = m.sets / m.max;
        const circ = 2 * Math.PI * m.r;
        const dash = circ * pct;
        return (
          <g key={m.label}>
            <circle cx={m.cx} cy={m.cy} r={m.r} stroke="rgba(0,0,0,0.05)" strokeWidth="9" fill="none"/>
            <circle cx={m.cx} cy={m.cy} r={m.r} stroke={color} strokeWidth="9" fill="none"
              strokeOpacity={pct >= 0.7 ? 0.9 : 0.4}
              strokeDasharray={`${dash} ${circ}`}
              strokeDashoffset={circ * 0.25}
              strokeLinecap="round"
            />
            <text x={m.cx} y={m.cy-2} fontSize="15" fontWeight="700" fill={color} fontFamily="system-ui" textAnchor="middle">{m.sets}</text>
            <text x={m.cx} y={m.cy+13} fontSize="8.5" fill="rgba(0,0,0,0.28)" fontFamily="system-ui" textAnchor="middle">set/sett</text>
            <text x={m.cx} y={m.cy+25} fontSize="8.5" fontWeight="600" fill="rgba(0,0,0,0.38)" fontFamily="system-ui" textAnchor="middle">{m.label}</text>
          </g>
        );
      })}
    </svg>
  );
}

function IllustrationTrend({ color }) {
  return (
    <svg width="100%" viewBox="0 0 360 180" fill="none" style={{ display: 'block' }}>
      <rect width="360" height="180" fill="#fff"/>
      {/* Assi */}
      <line x1="50" y1="20" x2="50" y2="150" stroke="rgba(0,0,0,0.07)" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="50" y1="150" x2="320" y2="150" stroke="rgba(0,0,0,0.07)" strokeWidth="1.5" strokeLinecap="round"/>
      {/* Area */}
      <path d="M60,130 L110,115 L160,118 L210,90 L260,70 L310,50 L310,150 L60,150Z" fill={color} fillOpacity="0.07"/>
      {/* Linea dati */}
      <polyline points="60,130 110,115 160,118 210,90 260,70 310,50"
        stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      {/* Trend line tratteggiata */}
      <line x1="60" y1="138" x2="310" y2="42" stroke={color} strokeWidth="1.5" strokeDasharray="5 4" opacity="0.35"/>
      {/* Punti */}
      {[[60,130],[110,115],[160,118],[210,90],[260,70],[310,50]].map(([x,y],i) => (
        <circle key={i} cx={x} cy={y} r={i===5?6:3.5} fill={i===5?color:'#fff'} stroke={color} strokeWidth="2"/>
      ))}
      {/* Badge trend */}
      <rect x="274" y="26" width="52" height="22" rx="8" fill={color} fillOpacity="0.12"/>
      <text x="300" y="41" fontSize="11" fontWeight="700" fill={color} fontFamily="system-ui" textAnchor="middle">+12%</text>
      {/* Label settimane */}
      {[[60,'S1'],[160,'S3'],[260,'S5'],[310,'Oggi']].map(([x,l]) => (
        <text key={l} x={x} y="164" fontSize="9" fill="rgba(0,0,0,0.22)" fontFamily="system-ui" textAnchor="middle">{l}</text>
      ))}
    </svg>
  );
}

function IllustrationCoach({ color }) {
  return (
    <svg width="100%" viewBox="0 0 360 180" fill="none" style={{ display: 'block' }}>
      <rect width="360" height="180" fill="#fff"/>
      {/* Bubble coach */}
      <rect x="30" y="25" width="200" height="70" rx="16" fill={color} fillOpacity="0.09" stroke={color} strokeOpacity="0.15" strokeWidth="1"/>
      <path d="M60,95 L50,110 L78,95Z" fill={color} fillOpacity="0.09"/>
      {/* Righe testo nel bubble */}
      <rect x="46" y="44" width="120" height="8" rx="4" fill={color} fillOpacity="0.3"/>
      <rect x="46" y="58" width="160" height="8" rx="4" fill={color} fillOpacity="0.18"/>
      <rect x="46" y="72" width="90" height="8" rx="4" fill={color} fillOpacity="0.12"/>
      {/* Pill risposta esercizio */}
      <rect x="160" y="120" width="170" height="44" rx="12" fill={color} fillOpacity="0.07" stroke={color} strokeOpacity="0.15" strokeWidth="1"/>
      <rect x="172" y="132" width="60" height="7" rx="3.5" fill={color} fillOpacity="0.25"/>
      <rect x="172" y="145" width="140" height="7" rx="3.5" fill={color} fillOpacity="0.14"/>
      {/* Dot typing */}
      {[240,256,272].map((x,i) => (
        <circle key={i} cx={x} cy="115" r="4" fill={color} fillOpacity={0.25 + i*0.2}/>
      ))}
      {/* Icona stella */}
      <circle cx="310" cy="35" r="22" fill={color} fillOpacity="0.1"/>
      <path d="M310 25 L312.4 31.6 L319.5 31.6 L313.9 35.7 L316.2 42.3 L310 38.2 L303.8 42.3 L306.1 35.7 L300.5 31.6 L307.6 31.6 Z"
        fill={color} fillOpacity="0.7"/>
    </svg>
  );
}

// ─── Dati feature ─────────────────────────────────────────────────────────────

const FEATURES = [
  {
    title: 'Come progredisci nel tempo',
    teaser: 'L\'app tiene traccia di ogni sessione e ti dice cosa fare nella prossima.',
    category: 'PROGRESSIONE',
    color: C.blue,
    colorL: '#E5F1FF',
    illustration: IllustrationProgressione,
    body: [
      { head: 'Come funziona', text: 'Ogni volta che ti alleni, l\'app confronta la sessione con le precedenti. Se stai migliorando, ti suggerisce di alzare il carico o le ripetizioni. Se invece hai avuto un calo, ti dice di tornare a un peso gestibile.' },
      { head: 'Perche non puoi sempre aggiungere peso', text: 'Il corpo non migliora in modo lineare. Ci sono settimane buone e settimane no. L\'app lo capisce e non ti chiede di forzare quando non ha senso farlo.' },
      { head: 'Progressione e stallo', text: 'Se per 3 sessioni consecutive non riesci a migliorare, l\'app riconosce lo stallo e cambia strategia: invece di aggiungere carico, ti suggerisce di lavorare sulle ripetizioni o recuperare prima di ricaricare.' },
    ],
  },
  {
    title: 'Quanto sei vicino al limite',
    teaser: 'L\'app misura lo sforzo percepito per capire se stai lavorando abbastanza o troppo.',
    category: 'INTENSITA',
    color: C.amber,
    colorL: '#FFF3E0',
    illustration: IllustrationIntensita,
    body: [
      { head: 'La scala dello sforzo', text: 'Quando inserisci RPE o RIR, stai comunicando all\'app quanto eri vicino al cedimento. RPE 8 significa: avresti potuto fare ancora 2 ripetizioni. RPE 10 significa massimo sforzo.' },
      { head: 'A cosa serve', text: 'Sapere l\'intensità media delle tue sessioni permette all\'app di capire se ti stai allenando troppo duro troppo a lungo, oppure se hai ancora margine per aumentare il carico.' },
      { head: 'Non obbligatorio', text: 'Se non sei abituato a usare RPE o RIR, puoi lasciare il campo vuoto. L\'app lavora lo stesso, ma con RPE riesce a darti suggerimenti molto più precisi.' },
    ],
  },
  {
    title: 'Il punteggio della settimana',
    teaser: 'Un numero che riassume quanto è stata efficace la tua settimana di allenamento.',
    category: 'STATISTICHE',
    color: C.green,
    colorL: '#E5F9EC',
    illustration: IllustrationScore,
    body: [
      { head: 'Cosa misura', text: 'Il punteggio considera quante sessioni hai fatto, quanto volume hai accumulato per gruppo muscolare, e quanto hai lavorato con intensità. Non basta allenarsi tante volte: conta anche la qualita delle sessioni.' },
      { head: 'Perche non e solo "sessioni fatte"', text: 'Tre sessioni brevi e leggere valgono meno di due sessioni dense e ben strutturate. Il punteggio premia la consistenza e la progressione, non solo la presenza in palestra.' },
      { head: 'Come usarlo', text: 'Non devi puntare al 100 ogni settimana. Settimane da 60-75 sono ottime per sostenibilita a lungo termine. Settimane sotto al 40 segnalano che qualcosa non sta funzionando.' },
    ],
  },
  {
    title: 'Quando il corpo non risponde',
    teaser: 'Come l\'app riconosce che hai bisogno di cambiare qualcosa prima di peggiorare.',
    category: 'RECUPERO',
    color: C.red,
    colorL: '#FFECEB',
    illustration: IllustrationStallo,
    body: [
      { head: 'La differenza tra giornata no e stallo', text: 'Una sessione scarsa puo succedere per mille motivi. Uno stallo e quando il pattern si ripete: stessa performance o peggio per piu sessioni di fila, nonostante il riposo.' },
      { head: 'Fatica accumulata', text: 'A volte non e l\'esercizio il problema, ma l\'accumulo di fatica generale. Se piu esercizi contemporaneamente smettono di progredire, l\'app lo segnala come segnale di recupero insufficiente, non di debolezza.' },
      { head: 'Cosa fare', text: 'L\'app ti suggerisce di ridurre il carico, non di smettere. Scalare di un passo e tornare a costruire con qualita e quasi sempre piu efficace che spingere oltre il limite.' },
    ],
  },
  {
    title: 'La settimana di scarico',
    teaser: 'Perche allenarsi meno per una settimana ti rende piu forte nel lungo periodo.',
    category: 'PROGRAMMAZIONE',
    color: C.purple,
    colorL: '#F5E9FF',
    illustration: IllustrationDeload,
    body: [
      { head: 'Cosa e un deload', text: 'Un deload e una settimana in cui riduci il volume di lavoro mantenendo i carichi. Non e una pausa: ti alleni, ma con meno serie. Serve a smaltire la fatica accumulata senza perdere forza.' },
      { head: 'Quando l\'app lo suggerisce', text: 'Quando nota che per 5-6 settimane consecutive lo sforzo percepito sale mentre la performance rimane piatta o scende. E il segnale che il recupero non sta tenendo il passo con lo stimolo.' },
      { head: 'Perche funziona', text: 'Il miglioramento fisico avviene durante il recupero, non durante l\'allenamento. Il deload crea lo spazio perche le adattazioni maturino. Dopo una settimana di scarico, molti atleti tornano piu forti di prima.' },
    ],
  },
  {
    title: 'Quanto stai allenando ogni muscolo',
    teaser: 'L\'app conta i set efficaci per gruppo muscolare e ti dice se stai bilanciando bene.',
    category: 'VOLUME',
    color: C.cyan,
    colorL: '#E5F5FF',
    illustration: IllustrationVolume,
    body: [
      { head: 'Set efficaci', text: 'Non tutti i set contano allo stesso modo. I primi set di riscaldamento servono a prepararsi, non a costruire muscolo. L\'app conta solo i set di lavoro veri, quelli fatti con carico sufficientemente pesante.' },
      { head: 'Bilanciamento', text: 'E facile concentrarsi sugli esercizi che piacciono e trascurare quelli che non piacciono. Il monitor del volume ti mostra se stai allenando tutti i gruppi muscolari in modo equilibrato.' },
      { head: 'Quanti set sono giusti', text: 'Per la maggior parte dei gruppi muscolari, 10-20 set a settimana e il range ottimale. Sotto i 6 set lo stimolo e insufficiente. Sopra i 25 il recupero diventa difficile.' },
    ],
  },
  {
    title: 'Il tuo trend complessivo',
    teaser: 'Il grafico in home che mostra se stai migliorando nel tempo su tutta la scheda.',
    category: 'DASHBOARD',
    color: '#32ADE6',
    colorL: '#E5F5FF',
    illustration: IllustrationTrend,
    body: [
      { head: 'Come si legge', text: 'La linea in home mostra la direzione generale delle tue performance nelle ultime settimane. Se sale, stai progredendo su piu esercizi contemporaneamente. Se scende, qualcosa non sta funzionando a livello sistemico.' },
      { head: 'Perche e utile', text: 'E facile focalizzarsi su un singolo esercizio e perdere di vista il quadro generale. Il grafico ti aiuta a vedere se il tuo allenamento sta andando nella direzione giusta nel tempo, non solo settimana per settimana.' },
      { head: 'Quando e piatto', text: 'Un grafico piatto per piu settimane di fila non e sempre un problema. E un problema se il tuo obiettivo e la progressione e hai l\'impressione di allenarti duro.' },
    ],
  },
  {
    title: 'L\'analisi del Coach AI',
    teaser: 'Come funziona l\'analisi intelligente della tua scheda e cosa ti dice esattamente.',
    category: 'COACH AI',
    color: '#AF52DE',
    colorL: '#F5E9FF',
    illustration: IllustrationCoach,
    body: [
      { head: 'Cosa vede il coach', text: 'Quando chiedi un\'analisi, il Coach AI riceve le ultime sessioni per ogni esercizio della tua scheda, il tuo profilo atleta e i pattern di stallo o regressione rilevati. Non inventa: lavora solo sui tuoi dati reali.' },
      { head: 'Cosa ricevi', text: 'Un verdetto sintetico su come sta andando la settimana, un\'analisi esercizio per esercizio con lo stato e il prossimo step concreto, e un piano per la prossima sessione con numeri esatti.' },
      { head: 'La cache', text: 'L\'analisi viene salvata sul tuo dispositivo. La prossima volta che apri la scheda, la vedi subito senza aspettare. Si aggiorna solo quando la richiedi di nuovo, cosi puoi consultarla anche offline.' },
    ],
  },
];

// ─── Card ─────────────────────────────────────────────────────────────────────

function FeatureCard({ feature, animDelay }) {
  const [open, setOpen] = useState(false);
  const Illustration = feature.illustration;

  return (
    <div
      onClick={() => setOpen(v => !v)}
      style={{
        ...CARD_STYLE,
        overflow: 'hidden',
        cursor: 'pointer',
        animation: `gpCardIn 0.48s cubic-bezier(0.22,1,0.36,1) ${animDelay}s both`,
      }}
    >
      {/* Immagine sopra — full width, sfondo bianco */}
      <div style={{
        width: '100%',
        background: '#ffffff',
        borderBottom: open ? `1px solid ${feature.color}18` : '1px solid rgba(0,0,0,0.04)',
        overflow: 'hidden',
      }}>
        <Illustration color={feature.color} />
      </div>

      {/* Testo sotto */}
      <div style={{ padding: '16px 18px 18px' }}>

        {/* Header row: pill + chevron */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          <div style={{
            display: 'inline-block',
            padding: '3px 9px',
            background: feature.colorL,
            borderRadius: 20,
            fontSize: 10,
            fontWeight: 700,
            color: feature.color,
            fontFamily: FONT_BODY,
            letterSpacing: 0.7,
          }}>
            {feature.category}
          </div>

          <div style={{
            width: 26, height: 26, borderRadius: 8,
            background: open ? feature.colorL : C.fill,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'background 0.2s, transform 0.28s cubic-bezier(0.22,1,0.36,1)',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            flexShrink: 0,
          }}>
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path d="M3 5l3.5 3.5L10 5" stroke={open ? feature.color : C.subtle} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>

        {/* Title */}
        <div style={{
          fontSize: 17, fontWeight: 700, color: C.text,
          fontFamily: FONT_BODY, letterSpacing: -0.3, lineHeight: 1.28,
          marginBottom: 6,
        }}>
          {feature.title}
        </div>

        {/* Teaser */}
        <div style={{
          fontSize: 14, color: C.subtle, fontFamily: FONT_BODY, lineHeight: 1.5,
        }}>
          {feature.teaser}
        </div>

        {/* Expanded body */}
        <div style={{
          overflow: 'hidden',
          maxHeight: open ? 1200 : 0,
          transition: open
            ? 'max-height 0.44s cubic-bezier(0.22,1,0.36,1)'
            : 'max-height 0.28s cubic-bezier(0.4,0,1,1)',
        }}>
          <div style={{
            marginTop: 16,
            paddingTop: 16,
            borderTop: `1px solid ${feature.color}18`,
            display: 'flex', flexDirection: 'column', gap: 14,
          }}>
            {feature.body.map((section, i) => (
              <div key={i}>
                <div style={{
                  fontSize: 11, fontWeight: 700, color: feature.color,
                  fontFamily: FONT_BODY, letterSpacing: 0.5,
                  textTransform: 'uppercase', marginBottom: 5,
                }}>
                  {section.head}
                </div>
                <div style={{
                  fontSize: 14, color: C.muted, fontFamily: FONT_BODY, lineHeight: 1.65,
                }}>
                  {section.text}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Page ─────────────────────────────────────────────────────────────────────

export function ImparaPage() {
  return (
    <div style={{
      fontFamily: FONT_BODY, background: BG, minHeight: '100vh',
      WebkitFontSmoothing: 'antialiased', MozOsxFontSmoothing: 'grayscale',
    }}>
      <div style={{ maxWidth: 560, margin: '0 auto', padding: '0 16px', paddingBottom: 100 }}>

        <div style={{ paddingTop: 56, marginBottom: 24 }}>
          <div style={{
            fontSize: 34, fontWeight: 800, color: C.text,
            fontFamily: FONT_BODY, letterSpacing: -0.8, lineHeight: 1.1, marginBottom: 6,
          }}>
            Impara
          </div>
          <div style={{ fontSize: 15, color: C.subtle, fontFamily: FONT_BODY }}>
            Come funziona ogni parte dell'app
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {FEATURES.map((feature, i) => (
            <FeatureCard key={feature.title} feature={feature} animDelay={0.05 * i} />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes gpCardIn {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
